module.exports = __webpack_public_path__ + "img/Riesenrad.f00c846a.jpg";